import type { UserAddressType } from '@/features/user/domain/enums/UserAddressType'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class UserAddressEntity {
  id?: number
  userId?: string
  userDisplayName?: string | null
  location?: LngLatEntity
  locationName?: string | null
  type?: UserAddressType
  homeNumber?: string | null
  description?: string | null
  regionId?: number
  regionName?: string | null
  createdAt?: string
}
